export default {
  RESET_PASSWORD: 'RESET_PASSWORD',
  PASSWORD: 'PASSWORD',
  REGISTER: 'REGISTER',
  CONTACT: 'CONTACT',
};
